import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Navbar from "@components/layout/Navbar";
import PatientHeaderProfile from "@components/patient-profile/PatientHeaderProfile";
import PatientTabsProfile from "@components/patient-profile/PatientTabsProfile";
import MainInfoTabProfile from "@components/patient-profile/MainInfoTabProfile";
import FormsTabProfile from "@components/patient-profile/FormsTabProfile";
import BottomActionsProfile from "@components/patient-profile/BottomActionsProfile";
import SelectFormModal from "@components/modals/SelectFormModal";
import PageTitleWithBack from "@components/common/PageTitleWithBack";
import { getAllTemplates } from "@services/template";
import { fetchFiles } from "@services/file";

export default function PatientProfile() {
  const navigate = useNavigate();
  const location = useLocation();
  const patient = location.state || {};
  const initialTab = location.state?.defaultTab === "forms" ? "forms" : "main";
  const [activeTab, setActiveTab] = useState(initialTab);
  const [showFormModal, setShowFormModal] = useState(false);
  const [formList, setFormList] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [selectMode, setSelectMode] = useState([]);

  useEffect(() => {
    getAllTemplates()
      .then((data) => {
        setFormList(data.data);
      })
      .catch((err) => console.error(err));
    if (!patient.id) {
      console.warn("Missing patient ID. Skipping file fetch.");
      return;
    } else {
      fetchFiles(patient.id)
        .then((data) => {
          setFileList(data.data);
        })
        .catch((err) => console.error(err));
    }
  }, [patient.id]);

  const handleEditPatient = () => {
    navigate("/new-patient", { state: { patient: patient } });
  };
  return (
    <div className="min-h-screen bg-white">
      <div className="sticky top-0 z-50">
        <Navbar showFieldSearch={false} />
      </div>
      <div className="mt-4 p-5">
        <PageTitleWithBack
          title="Patient Profile"
          onBack={() => navigate("/")}
        />
        <PatientHeaderProfile patient={patient} />
        <PatientTabsProfile activeTab={activeTab} setActiveTab={setActiveTab} />
        <div
          className="p-5 text-gray-700"
          style={{ minHeight: "calc(100vh - 40vh)" }}
        >
          {activeTab === "main" && <MainInfoTabProfile patient={patient} />}
          {activeTab === "forms" && <FormsTabProfile forms={fileList} />}
        </div>
        <BottomActionsProfile
          activeTab={activeTab}
          onEditPatient={handleEditPatient}
          onFillNewForm={() => {
            setShowFormModal(true);
            setSelectMode("fill");
          }}
          onSendFormToPatient={() => {
            setShowFormModal(true);
            setSelectMode("send");
          }}
        />
      </div>
      {showFormModal && (
        <SelectFormModal
          onClose={() => setShowFormModal(false)}
          title={
            selectMode === "send"
              ? "Choose a form to send to the patient to fill in at home."
              : "Choose a form to fill out for this patient."
          }
          forms={formList}
          patient_id={patient.id}
          patient_name={`${patient.first_name} ${patient.last_name}`}
          mode={selectMode}
        />
      )}
    </div>
  );
}
